<template>
    <div>
        <div class="d-flex align-items-center mb-2">
            <input type="text" name="discount" autocomplete="off" class="py-1 ps-1 me-2" placeholder="Enter Discount Code" v-model="discountCode">
            <button class="btn btn-secondary" type="button" @click="applyDiscount()" :disabled="discountCode == ''">
                Apply
            </button>
        </div>
        <transition-group name="fade">
            <template v-if="Object.keys(discountMessages).length > 0">
                <div v-for="message, key in discountMessages" class="alert d-flex justify-content-between align-items-center" :class="message.success == true ? 'alert-primary' : 'alert-danger'" role="alert" :key="key">
                    <b>{{ message.message }}!</b>
                </div>
            </template>
        </transition-group>
        <div v-if="Object.keys(discounts).length > 0 || Object.keys(promoEntries).length > 0">
            <div v-if="Object.keys(discounts).length > 0">
                <b>Applied Discounts</b>
                <div v-for="(basketDiscount, key) in discounts" :key="basketDiscount.id">
                    <div class="d-flex justify-content-between align-items-center py-2">
                        <template v-if="key != 'total_discount' && basketDiscount.type != 'promo_entry'">
                            <span class="flex-fill">{{ basketDiscount.discount_code }}</span>
                            <span>-&pound;{{ basketDiscount.discount_amount }}</span>
                        </template>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(promoEntries).length > 0">
                <b>Promotions entered</b>
                <div v-for="(basketDiscount, key) in promoEntries" :key="key" class="d-flex justify-content-between align-items-center py-2">
                    <template v-if="basketDiscount.type == 'promo_entry'">
                        <span class="flex-fill">{{ basketDiscount.discount_name }}</span>
                        <span>{{ basketDiscount.discount_code }}</span>
                    </template>
                </div>
            </div>
            <small class="clear-discounts" @click="clearDiscounts()">(Clear Discounts)</small>
        </div>
    </div>
</template>

<script>
    import { Field , ErrorMessage} from 'vee-validate';

    export default {
        props: ['basket'],
        components: { Field, ErrorMessage },
        data() {
            return {
                discountCode: '',
                discountMessages: [],
                discountError: '',
                showAlerts: false
            }
        },
        mounted() {

        },
        methods: {
            async applyDiscount() {
                this.emitter.emit('isLoading', true);

                var formattedCode = this.discountCode.replace('%', '%25');

                const response = await axios.post('/ajax/apply_discount/' + formattedCode);
            
                if(response.data.discount_applied.discount_applied == true) {
                    
                    if(!response.data.basket || Object.keys(response.data.basket).length < 1) {
                        window.location.href = this.baseUrl + '/error';
                    }

                    this.emitter.emit('refreshBasket');
                }

                //Clear existing messages
                //Server stores last entry in session.. maybe change later.
                this.discountCode = '';
                this.discountMessages = [];
                this.discountMessages = response.data.discount_applied.messages;
                setTimeout(() => this.discountMessages = [], 2000);

                this.emitter.emit('isLoading', false);
            },
            async clearDiscounts() {
                this.emitter.emit('isLoading', true);

                const response = await axios.post('/ajax/clear_discounts/');

                if(response.data.success) {
                    this.emitter.emit('refreshBasket');
                }

                this.emitter.emit('isLoading', false);
            }
        },
        computed: {
            discounts() {
                const basketItems = Object.values(this.basket.basket_discounts)

                 return basketItems.filter((basket_item) => {
                    return basket_item.type == 'amount_off';
                });
            },
            promoEntries() {
                const basketItems = Object.values(this.basket.basket_discounts)

                 return basketItems.filter((basket_item) => {
                    return basket_item.type == 'promo_entry';
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .clear-discounts {
        text-decoration: underline;
        cursor: pointer;
    }
</style>